import Link from "next/link";
import ImageComponent from "components/Image";
import MaxWidthWrapper from "components/Tiles/commonComponents/MaxWidthWrapper";
import "./style.css";
import Icon from "components/Icon";

type AnimatedCardData = {
  cardFooterTitle?: string;
  cardFooterIcon?: string;
  link?: string;
  leftText?: {
    title?: string;
    subtitle?: string;
  };
  rightText?: {
    title?: string;
    subtitle?: string;
  };
};
type AnimatedCardsProp = {
  bgColor?: string;
  cards?: AnimatedCardData[];
};
function AnimatedCards({ bgColor, cards = [] }: AnimatedCardsProp) {
  return (
    <section id="AnimatedCards-133" style={{ backgroundColor: bgColor }}>
      <MaxWidthWrapper className="tile-container relative">
        <div className={`ticker-wrap box-content block overflow-hidden`}>
          <div className="ticker flex w-full flex-nowrap items-start justify-start whitespace-nowrap pr-[100%]">
            {[...cards, ...cards].map((item, index) => (
              <Link
                key={`animated-card-${index}`}
                href={item.link || ""}
                className={`ticker__item h-auto min-h-1 w-full max-w-[350px] flex-[0_0_auto]`}
              >
                <div className={`mx-[15px] flex flex-col gap-[15px] px-[10px]`}>
                  <div className={`relative flex-grow`}>
                    <div className={"relative h-[400px] w-full overflow-hidden rounded-[15px]"}>
                      <ImageComponent
                        className={"h-[400px] rounded-[15px] object-cover"}
                        src={"http://soldave.localhost:5010/bg-sample.png"}
                        alt="example image"
                        fill
                      />
                    </div>
                    <div
                      className={`absolute inset-[auto_0%_0%] bottom-0 left-0 right-0 flex h-1/2 items-end justify-center rounded-b-[15px] bg-bottomTickerShadow px-[10px] pb-5`}
                    >
                      <div className={`flex w-full flex-col items-center justify-center`}>
                        {item.leftText && (
                          <>
                            <div className={`text-xl font-bold leading-[1.5] text-white`}>
                              {item.leftText?.title || ""}
                            </div>
                            <div className={`text-sm text-white`}>{item.leftText?.subtitle}</div>
                          </>
                        )}
                      </div>
                      <div className={`flex w-full flex-col items-center justify-center`}>
                        {item.rightText && (
                          <>
                            <div className={`text-xl font-bold leading-[1.5] text-[#5becd4]`}>
                              {item.rightText?.title || ""}
                            </div>
                            <div className={`text-sm text-white`}>{item.rightText?.subtitle}</div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  {item.cardFooterTitle && (
                    <div className={`flex items-center justify-center gap-3 pt-2 font-medium`}>
                      {item.cardFooterIcon && (
                        <Icon name={item.cardFooterIcon as any} className="h-5 w-5" strokeWidth={3} />
                      )}
                      {item.cardFooterTitle}
                    </div>
                  )}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </MaxWidthWrapper>
    </section>
  );
}

export default AnimatedCards;
